import { useQuery } from '@tanstack/react-query'
import { api } from '@api'
import { Scope } from '@utils'

export type ConversationParticipant = {
  id: string
  fullName: string | null
  avatarUrl: string | undefined
  role?: string
}

export type Conversation = {
  id: string
  name: string | null
  scope: Scope | null
  participants: ConversationParticipant[]
  lastMessage: {
    content: string
    createdAt: string
  } | null
  unreadCount?: number
  // When the other participant last read this conversation (ISO date) — used for
  // the "Vu" read receipt under sent messages.
  othersLastReadAt?: string | null
  createdAt: string
  updatedAt: string
}

const fetchConversationById = async (id: string): Promise<Conversation> => {
  const { data } = await api.get<Conversation>(`/conversations/${id}`)
  return data
}

export const useGetConversationById = (id: string) => {
  return useQuery<Conversation>({
    queryKey: ['conversation', id],
    queryFn: () => fetchConversationById(id),
    enabled: !!id,
  })
}

